{
  "types": {
    "Instruction": [
      { "name": "salt", "type": "uint256" },
      { "name": "maxExecutions", "type": "uint256" },
      { "name": "action", "type": "address" },
      { "name": "deactivateInstruction", "type": "DeactivateInstruction" }
    ],
    "DeactivateInstruction": [
      { "name": "instructionId", "type": "bytes32" },
      { "name": "fee", "type": "Fee" }
    ],
    "Fee": [
      { "name": "token", "type": "address" },
      { "name": "maxBaseFeePerGas", "type": "uint256" },
      { "name": "maxPriorityFeePerGas", "type": "uint256" },
      { "name": "executionFee", "type": "uint256" }
    ]
  }
}
